module.exports = __webpack_public_path__ + "img/martinique.4de172f5.svg";